import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';

export interface ILogStyles {
  root: IStyle;
}

export const logStylesDefault = (theme: IH2OTheme): Partial<ILogStyles> => ({
  root: {
    whiteSpace: 'break-spaces',
    fontFamily: 'monospace',
    padding: '10px 110px',
    backgroundColor: theme.palette?.gray900,
    color: theme.palette?.white,
    flex: 1,
    overflow: 'auto',
    height: '100%',
    maxHeight: '100%',
  },
});
